<template>
  <div class="program-cards-sale">
    <div class="container">
      <div class="row">
        <div class="pcs-heading col col-8 offset-2 md-6 md-offset-3">
          <h1 class="pcs-heading-title h2">
            {{ title }}
          </h1>
          <span class="pcs-heading-subtitle">
            {{ subtitle }}
          </span>
        </div>
        <div v-if="bundle.courses && bundle.courses.length" class="pcs-content">
          <div v-for="(cols, i) in courses" :key="i" class="col col-6">
            <div
              v-for="(course, idx) in cols" :key="idx" class="pcs-course"
              :class="[`course-${course.key}`, { expanded: course.expanded }]"
            >
              <span class="course-number">Course {{ course.number }}</span>
              <h2 class="h3">
                {{ course.name }}
              </h2>
              <p class="description">
                {{ course.shortDescription }}
              </p>
              <ul v-if="course.curriculum && course.curriculum.length" class="course-sections">
                <li v-for="(section, idx2) in course.curriculum" :key="idx2">
                  <span>
                    <span class="section-number">{{ sectionNumber(idx2) }}</span>
                    <span class="section-name">{{ section.sectionName }}</span>
                  </span>
                  <span class="section-lessons">{{ sectionLessons(section) }} Lessons</span>
                </li>
              </ul>
              <div v-if="course.curriculum.length > 5" class="see-more">
                <a href="#" @click.prevent="expand(course.key)">{{ bundle.courses[course.key].expanded ? 'See less' : 'See more' }} <IconArrowDown /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="pcs-benefit col col-6 offset-3">
          <div class="benefit">
            <h2>
              Who Can Benefit from This Bundle?
            </h2>
            <p class="body-1">
              {{ bundle.benefitDescription }}
            </p>
          </div>
          <div class="button">
            <button class="btn-primary btn-lg" @click="$emit('subscribe')">
              Buy Now For ${{ bundle.discountedPrice }}
            </button>
            <p>
              Billed once. Lifetime access to all course materials and updates
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrowDown from '../../assets/svg/icon-expand.svg?vue-component';

export default {
  components: { IconArrowDown },
  props: {
    c: { type: Object, default: () => {}, required: true },
  },
  data() {
    return {
      moduleSeeMore: false,
      bundle: {
        ...this.c, courses: this.c.courses.map((c, key) => ({ ...c, key, expanded: false })) || [],
      },
      title: this.c.curriculumTitle || 'Beginner-Friendly Curriculum Designed with your Practical Needs in Mind',
      subtitle: this.c.curriculumSubTitle || 'Learn in-demand skills with a structured course that prepares you for the world of data science as it is today.',
    };
  },
  computed: {
    courses() {
      const array = [[]];
      const columns = this.$store.state.layout === 'desktop' ? 2 : 1;

      if (columns > 1) {
        array.push([]);
      }

      for (let i = 0; i < this.bundle.courses.length; i += 1) {
        array[i % columns].push({ ...this.bundle.courses[i], number: i + 1 });
      }

      return array;
    },
  },
  methods: {
    expand(key) {
      if (this.bundle.courses[key].expanded) {
        const el = document.querySelector(`.course-${key}`);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
        }
      }
      this.bundle.courses[key].expanded = !this.bundle.courses[key].expanded;
    },
    sectionNumber(i) {
      return `${(i + 1 < 10 ? '0' : '')}${i + 1}`;
    },
    sectionLessons(section) {
      return `${(section.lessons < 10 ? '0' : '')}${section.lessons}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.pcs-heading {
  text-align: center;

  .pcs-heading-subtitle {
    color: #545C69;
    font-size: 18px;
    line-height: 1.1;
    font-weight: 400;
  }
}

.pcs-content {
  margin: var(--spacing-60) 0 var(--spacing-100);

  > * + * {
    margin-top: 300px;
  }
}

.pcs-course {
  padding: 55px 50px;
  box-shadow: 0 16px 30px rgba(0, 12, 31, 0.08);
  border-radius: 10px;

  + .pcs-course {
    margin-top: 30px;
  }

  .course-number {
    color: var(--main-dark-light-4);
    font-size: 18px;
    line-height: 1.1;
  }

  .h3 {
    margin-top: var(--spacing-4);
  }

  .description {
    margin-top: var(--spacing-24);
    color: var(--main-dark-light-4);
    line-height: 1.5;
  }

  .course-sections {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    max-height: 326px;
    transition: all 300ms ease;

    li {
      display: flex;
      justify-content: space-between;
      align-items: start;
      line-height: 1.5;
      font-weight: 600;

      + li {
        padding-top: 18px;
        margin-top: 18px;
      }

      .section-number {
        color: var(--accent);
        margin-right: var(--spacing-8);
      }

      > div {
        min-width: 0;
        display: flex;
      }

      .section-lessons {
        font-weight: 400;
        color: var(--main-dark-light-4);
        flex: 0 0 auto;
      }
    }
  }

  .see-more {
    position: relative;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-16) 0;
    margin-top: var(--spacing-16);

    a {
      color: var(--accent);
      font-weight: 500;
    }

    svg {
      transition: all 300ms ease;

      path {
        &[fill] {
          fill: var(--accent);
        }

        &[stroke] {
          stroke: var(--accent);
        }
      }
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 100%;
      left: 0;
      width: 100%;
      height: 77px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0) -13.64%, #FFF 66.26%);
      transition: all 300ms ease;
    }
  }

  &.expanded {
    .course-sections {
      max-height: 1500px;
    }

    .see-more {
      svg {
        transform: rotate(180deg);
      }

      &:after {
        opacity: 0;
        z-index: -1;
      }
    }
  }
}

.pcs-benefit {
  text-align: center;

  .body-1 {
    margin-bottom: 0;
  }

  .button {
    max-width: 350px;
    margin: var(--spacing-60) auto 0;

    p {
      color: #545C69;
    }
  }
}

@include bp($bp-laptop) {
  .pcs-benefit .button {
    max-width: 310px;
  }
}

@include bp($bp-phone) {
  .pcs-course {
    padding: 40px var(--spacing-32);
  }

  .course-sections li {
    position: relative;

    + li:before {
      content: '';
      position: absolute;
      display: block;
      height: 3px;
      top: 0;
      width: 100%;
      background-image: linear-gradient(to right, rgba(0, 12, 31, 0.24) 33%, rgba(255, 255, 255, 0) 0%);
      background-position: bottom;
      background-size: 10px 2px;
      background-repeat: repeat-x;
    }

    .section-lessons {
      display: none;
    }
  }
}
</style>
